module.exports = __webpack_public_path__ + "static/media/loading.156ba683.svg";